/* unplugin-vue-components disabled */import script from "./noteDraftManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./noteDraftManager.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__